import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChat = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M14.444 7.769v-5.55C14.444.996 13.448 0 12.222 0h-10A2.223 2.223 0 0 0 0 2.22v5.549c0 1.224.997 2.22 2.222 2.22v1.88c0 .277.316.436.538.27l2.875-2.154h6.587a2.218 2.218 0 0 0 2.222-2.216Zm3.334-2.22h-2.222v2.22a3.337 3.337 0 0 1-3.334 3.33H6.667v2.219c0 1.224.996 2.22 2.222 2.22h4.365l2.874 2.153a.337.337 0 0 0 .539-.27v-1.884h1.11A2.223 2.223 0 0 0 20 13.317V7.77c0-1.225-.997-2.22-2.222-2.22Z" })
});
export default SvgIconChat;
